import { FormGroup, ValidationErrors } from '@angular/forms';

/**
 * Checks if at least one of provided controls has value
 * @param controlKeys controls to check
 * @returns
 */
export function atLeastOneRequiredControlValidator(controlKeys: string[]) {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const controls = controlKeys.map((key) => formGroup.controls[key]);
    const controlValues: boolean[] = controls.map((control) => {
      if (control.value === null || control.value === undefined) {
        return false;
      }
      if (control.value instanceof Array) {
        return control.value.length > 0;
      }
      if (typeof control.value === 'object') {
        return Object.keys(control.value).length > 0;
      }
      return !!control.value;
    });

    if (controlValues.some((hasValue) => hasValue)) {
      return null;
    }
    return { atLeastOneRequired: true };
  };
}
